var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "contact-linked-companies typographies-paragraph-medium-semibold"
    },
    [
      _vm._l(_vm.companiesToDisplay, function(company, index) {
        return [
          _c("CompassLink", {
            key: index,
            attrs: { type: "secondary", link: company.link },
            domProps: { innerHTML: _vm._s(company.name) }
          }),
          _vm._v(" "),
          _c("span", { key: company.name }, [_vm._v(", ")])
        ]
      }),
      _vm._v(" "),
      !_vm.showRemaining && _vm.hasMoreThan5Companies
        ? _c(
            "button",
            {
              staticClass: "contact-linked-companies__button",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                  return _vm.handleShowRemaing($event)
                }
              }
            },
            [
              _vm._v(
                "\n        + " +
                  _vm._s(_vm.remainingCompanies) +
                  " " +
                  _vm._s(_vm.$l10n.__("autres")) +
                  "\n    "
              )
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }